import React from 'react'
import { Highlight } from 'react-instantsearch/dom';
import { connect } from 'kea'
import { pick, values, compact } from 'lodash'

import logic from '~/components/search/logic'

const contactValues = [
  'contact__first_name',
  'contact__last_name',
  'contact__email',
  'contact__phone',
  'contact__company'
];

@connect({
  actions: [
    logic, [
      'navigateTo',
    ]
  ],
})
class Order extends React.Component {
  handleClick = (e) => {
    e.preventDefault();

    const { hit } = this.props;
    const { navigateTo } = this.props.actions;

    const link = `/orders/${hit.objectID}/`;

    navigateTo(link);
  };

  render() {
    const {hit} = this.props;
    let contactDisplay = compact(values(pick(hit, contactValues))).join(' ');
    let contentsDisplay = hit.contents__name;

    if(contentsDisplay && contentsDisplay.constructor === Array) {
      contentsDisplay = contentsDisplay.join(', ')
    }

    return (
      <div className="result order-result" onClick={ this.handleClick }>
        <h4 className="primary hit-invoice_number">
          <Highlight attribute="invoice_number" hit={hit} />
        </h4>
        <div>
          { contactDisplay.length > 0 ?
            <span className="secondary hit-contact-name">
              { contactDisplay }
            </span>
            : null }
        </div>
        <div>
          { contentsDisplay ?
            <span className="secondary hit-contents__name">
              { contentsDisplay }
            </span>
          : null }
        </div>
      </div>
    )
  }
}

export default Order